import { PHASE } from '..'
import betaConfigs from './beta'
import beta1Configs from './beta1'
import developmentConfigs from './development'
import productionConfigs from './production'
import qaConfigs from './qa'
import stageLinks from './stage'

const configs =
  {
    qa: qaConfigs,
    development: developmentConfigs,
    production: productionConfigs,
    stage: stageLinks,
    beta: betaConfigs,
    beta1: beta1Configs,
  }[PHASE] ?? developmentConfigs

export default configs
